import React, { Fragment } from 'react';
import { observer } from 'mobx-react';

import TextField from 'app/commonComponents/TextField';
import ExpandableText from 'app/components/expandableText';
import {
  FormColumn,
  FormRowGroup,
} from 'modules/tickets/components/common/dialog/TicketFormUtils';
import form from 'modules/ticketPublicPage/stores/vouchers/form';
import view from 'modules/ticketPublicPage/stores/vouchers/view';
import ValuesChoiceDropdown from './common/ValuesChoiceDropdown';
import InfoTooltip from 'app/components/InfoTooltip';
import { colors } from 'app/variables';
import { Divider } from './styles/_buyVoucher';

export const textFieldLabelStyle = {
  fontSize: '0.6rem',
  fontWeight: 'initial',
  color: colors.dustyGray,
};

const Initial = observer(() => {
  const { formValues, errors, setFormValue, validateField } = form;
  const {
    activeObject: { description },
  } = view;

  return (
    <Fragment>
      <FormRowGroup style={{ width: '100%', marginBottom: '1rem' }}>
        <FormColumn style={{ width: '100%' }}>
          <ExpandableText buttonPosition="start" text={description} />
          <Divider style={{ marginTop: '1rem' }} />
          <div style={{ padding: '1rem 0', fontWeight: '500' }}>
            {i18n.gettext('Personalize your voucher')}
          </div>
          <div style={{ width: '100%' }}>
            <ValuesChoiceDropdown />
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              gap: '1rem',
            }}
          >
            <TextField
              label={i18n.gettext('To (Recipient)')}
              required
              placeHolder={errors.to || i18n.gettext('e.g. John')}
              onChange={(e) => setFormValue('recipient', e.target.value)}
              onBlur={() => validateField('recipient')}
              value={formValues.get('recipient')}
              maxLength="20"
              error={errors.get('recipient')}
              labelStyle={textFieldLabelStyle}
              style={{ width: '100%' }}
            />
            <TextField
              label={i18n.gettext('From (Sender)')}
              required
              placeHolder={errors.from || i18n.gettext('e.g. Jane')}
              onChange={(e) => setFormValue('sender', e.target.value)}
              onBlur={() => validateField('sender')}
              value={formValues.get('sender')}
              maxLength="20"
              error={errors.get('sender')}
              labelStyle={textFieldLabelStyle}
              style={{ width: '100%' }}
            />
          </div>
        </FormColumn>
      </FormRowGroup>
      <FormRowGroup style={{ marginBottom: '1rem' }}>
        <TextField
          label={
            <Fragment>
              <span>{i18n.gettext('Greeting message')}</span>
              <InfoTooltip
                width="1rem"
                height="1rem"
                tooltipStyles={{ fontSize: '0.75rem', padding: '0.5rem' }}
                description={i18n.gettext(
                  'This message will be printed onto the voucher.'
                )}
              />
            </Fragment>
          }
          aria-label={i18n.gettext(
            'Greeting message. This message will be printed onto the voucher.'
          )}
          labelStyle={{ ...textFieldLabelStyle, paddingBottom: '0.6rem' }}
          inputStyle={{ resize: 'none' }}
          rows={3}
          multiLine={true}
          visibleMaxLength={256}
          name="greeting_message"
          error={errors.get('greeting_message')}
          placeholder={
            errors.get('greeting_message') ||
            i18n.gettext('e.g. Happy Birthday (optional)')
          }
          value={formValues.get('greeting_message')}
          onChange={(e) => {
            validateField('greeting_message');
            setFormValue('greeting_message', e.target.value);
          }}
          style={{ width: '100%' }}
        />
      </FormRowGroup>
    </Fragment>
  );
});

export default Initial;
